<template>
  <div :class="['form__field-holder', {'form__field-holder_error': !!errors.has(newName), 'checkbox-item' : extraStylingIsEnabled}]"
       data-vv-value-path="model"
       :data-vv-as="label ? label : labelHtml">
    <div class="form__field-box">
      <label class="form__label" v-if="label">
        {{label}}
      </label>
      <label class="form__label" v-if="labelHtml" v-html="labelHtml" style="width: auto; margin-right: 15px;"></label>

      <input v-if="setForm"
             type="hidden"
             :form="form"
             :name="`hidden_` + name"
             v-model="model"
             v-validate="rules">
      <input v-else
             type="hidden"
             :name="`hidden_` + name"
             v-model="model"
             v-validate="rules">

      <div :class="['v-checkbox',{
          'v-checkbox--is-dirty': isDirty,
          'v-checkbox--is-disabled': disabled,
          'v-checkbox--has-label': Object.keys(options).length || this.$slots.default}]">
        <template v-if="Object.keys(options).length">
          <label :class="['v-checkbox__item', disabled ? 'v-checkbox__item--disabled' : '']"
                 v-for="(option, key) in options"
                 :key="key">
            <input v-if="isSingleCheckbox && setForm"
                   :name="name"
                   :form="form"
                   type="checkbox"
                   :value="key"
                   :true-value="1"
                   :false-value="0"
                   v-model="model"
                   :disabled="disabled"
                   :id="id"
                   @change="disableAutoComplete(); stateChange(model)">
            <input v-else-if="isSingleCheckbox"
                   :name="name"
                   type="checkbox"
                   :value="key"
                   :true-value="1"
                   :false-value="0"
                   v-model="model"
                   :disabled="disabled"
                   :id="id"
                   @change="disableAutoComplete(); stateChange(model)">
            <input v-else-if="setForm"
                   :name="name"
                   :form="form"
                   type="checkbox"
                   :value="key"
                   true-value="yes"
                   false-value="no"
                   v-model="model"
                   :disabled="disabled"
                   :id="id"
                   @change="disableAutoComplete(); stateChange(model)">
            <input v-else
                   :name="name"
                   type="checkbox"
                   :value="key"
                   true-value="yes"
                   false-value="no"
                   v-model="model"
                   :disabled="disabled"
                   :id="id"
                   @change="disableAutoComplete(); stateChange(model)">

            <div class="v-checkbox__indicator"></div>

            <template v-if="option">
              <span v-html='option'></span>
            </template>
          </label>
        </template>
        <label class="v-checkbox__item"
               v-else>
          <input :name="name"
                 type="checkbox"
                 v-model="model"
                 :disabled="disabled"
                 @change="disableAutoComplete(); stateChange(model)">
          <div class="v-checkbox__indicator"></div>
          <template>
            <slot></slot>
          </template>
        </label>
        <!--     <div class="v-input__error" v-if="errors.has(newName)">
              {{ errors.first(newName) }}
            </div> -->
      </div>
    </div>
  </div>
</template>

<script>
  import field from '../mixins/field'

  export default {
    computed: {
      isDirty() {
        return !!this.model
      }
    },
    data() {
      return {
        model: this.isSingleCheckbox ? (this.value && this.value != 0 ? 1 : 0) : (this.hasMultipleValues ? this.value : (this.value ? [this.value] : this.values)),
      }
    },
    mixins: [field],
    methods: {
      stateChange(model) {
        this.$emit('changed', model);
      },
      disableAutoComplete() {
        let elements = document.querySelectorAll('[autocomplete="off"]');

        if (!elements) {
          return;
        }

        [...elements].forEach(element => {
          element.setAttribute('readonly', 'readonly');

          setTimeout(() => {
            element.removeAttribute('readonly');
          }, 500);
        });
      }
    },
    props: {
      label: {
        default() {
          return ''
        },
        type: String
      },
      options: {
        default: () => { return {} },
        type: [Object, Array]
      },
      values: {
        default: () => { return [] },
        type: Array
      },
      value: {
        default: '',
        type: [Number, String, Array]
      },
      labelHtml: {
        default() {
          return ''
        },
        type: String
      },
      extraStylingIsEnabled: {
        default: false,
        type: Boolean
      },
      setForm: {
        default: false,
        type: Boolean
      },
      form: {
        default() {
          return ''
        },
        type: String
      },
      id: {
        default: '',
        type: String
      },
      isSingleCheckbox: {
        default: false,
        type: Boolean
      },
      hasMultipleValues: {
        default: false,
        type: Boolean
      },
    }
  }
</script>


// WEBPACK FOOTER //
// resources/assets/js/admin/components/VCheckboxesPublic.vue